// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';

/**
 * A lightweight controlled checkbox for use outside of Form context.
 * Replicates the visual structure of the withFormField-wrapped Checkbox
 * (with-form-field wrapper + label + input.input[type=checkbox]) but accepts
 * standard React controlled props (checked, onChange) instead of requiring
 * Form context wiring.
 */
function MarkersCheckbox({checked, disabled, label, onChange}) {
    return (
        <div className="with-form-field">
            <label className="with-form-field--label">
                <input
                    className="input"
                    type="checkbox"
                    checked={checked}
                    disabled={disabled}
                    onChange={(e) => onChange(e.target.checked)}
                />
                {' '}{label}
            </label>
        </div>
    );
}

MarkersCheckbox.propTypes = {
    checked: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default MarkersCheckbox;
